const Form090TC = {
    stepNames: {
        importantNotes: "重要提示",
        applicationInformation: "申請訊息",
        confirmation: "確認",
    },

    importantNotesContent: {
        title: "注意",
        p1: "在填寫此表格前，請細心閱讀個人資料收集聲明。",
        declarationTitle: "聲明",
        declarationList: [
            "教育局將使用本表格所載的個人資料作處理有關獲提名教師出任課程發展議會轄下各學習領域及功能委員會委員的事宜。",
            "你必須提供所需的個人資料。如未能提供所需資料，或會影響其後的遴選工作及結果。",
            "你有權要求查閱及更正教育局所持有關你的個人資料。如欲查詢本表格所收集的個人資料，請聯絡課程發展議會秘書處。",
        ],
    },
    label: {
        sectionA: {
            headerTitle: "甲部 （由獲提名教師填寫）",
            part1TitleBefore: "1 擬提名加入的委員會",
            part1TitleAfter: '（請於適當的空格加上"✓"（可選多於一個））',
            part2Title: "2 個人資料",
            englishSurname: "英文姓名（香港身份證）（姓氏）",
            englishOtherName: "英文姓名（香港身份證）（名字）",
            chineseName: "中文姓名（香港身份證）",
            title: "稱呼",
            otherTitle: "（請註明）",
            schoolName: "學校名稱",
            telNo: "個人聯絡電話",
            email: "電郵地址",
            part3Title: "3 已獲取的學歷/專業資格（按時間順序列出）",
            collegeName: "大學/學院",
            qualification: "資歷/學位",
            obtainedYear: "考獲年份",
            majorSubject: "主修科目",
            otherSubject: "其他科目",
            beforePart4TitleBoldText: "請提供",
            part4TitleBoldText: "過去十年（2012/13-2022/23學年）",
            afterPart4TitleBoldText: "的相關資料",
            part4ATitle: "4a 教學經驗（按時間順序列出）",
            schoolYearFromPart4A: "學年（由）",
            schoolYearToPart4A: "學年（至）",
            present: "現時",
            schoolNamePart4A: "學校名稱",
            subjectPart4A: "任教科目",
            levelPart4A: "年級",
            part4bTitle: "4b 在校內擔任的其他主要職務",
            schoolYearFromPart4B: "學年（由）",
            schoolYearToPart4B: "學年（至）",
            subjectPanel:
                "科組/功能組別/其他（例如：各科科組、訓導組、教務組）",
            positionPart4B: "職位（例如：科主任、訓導主任、教務主任）",
            part5Title:
                "5 與課程發展有關的專業組織的工作經驗（例如：課程發展議會的工作、香港考試及評核局的工作、專業學會的經驗）",
            schoolYearFromPart5: "學年（由）",
            schoolYearToPart5: "學年（至）",
            committeePart5:
                "委員會/組織（例如：課程發展議會委員會、香港考試及評核局科目委員會）",
            positionPart5: "職位（例如：主席、秘書、委員）",
            part6Title:
                "6 其他與課程發展相關的專業經驗（例如：師資培訓、編訂學與教參考資料、從事研究/發表學術論著/統籌校本課程發展的工作）",
            schoolYearFromPart6: "學年（由）",
            schoolYearToPart6: "學年（至）",
            descriptionPart6:
                "項目/詳情（例如：專題講座、工作坊、種籽計劃、行動研究）",
            positionPart6: "職位（例如：講者、統籌員、作者）",
        },
        sectionB: {
            headerTitle: "乙部 （由校長填寫）",
            recommendation: "評語（可選擇是否填寫）",
            conditionConfirm:
                "本人現就提名上述教師出任課程發展議會轄下委員會委員一事，證明甲、乙兩部分所填報的資料屬實。本人明白有關委員會或會在授課日的上午或下午舉行會議，並同意盡量允許他/她出席會議。（若同意請在方格內加上✓號）",
            principalEnglishName: "校長姓名（英文）",
            principalChineseName: "校長姓名（中文）",
            title: "稱謂",
            otherTitle: "（請註明）",
            email: "電郵地址",
        },
    },

    titleOptions: {
        Mr: "先生",
        Ms: "女士",
        Miss: "小姐",
        Other: "其他",
    },
    committeesOptions: [
        {
            title: "中國語文教育",
            subTitle: "學習領域委員會",
        },
        {
            title: "英國語文教育",
            subTitle: "學習領域委員會",
        },
        { title: "數學教育", subTitle: "學習領域委員會" },
        {
            title: "個人、社會及人文教育",
            subTitle: "學習領域委員會",
        },
        { title: "科學教育", subTitle: "學習領域委員會" },
        { title: "科技教育", subTitle: "學習領域委員會" },
        { title: "藝術教育", subTitle: "學習領域委員會" },
        { title: "體育", subTitle: "學習領域委員會" },
        {
            title: "幼兒教育",
            subTitle: "功能委員會",
        },
        {
            title: "特殊教育需要",
            subTitle: "功能委員會",
        },
        { title: "資優教育", subTitle: "功能委員會" },
        {
            title: "學習資源及支援",
            subTitle: "功能委員會",
        },
        { title: "應用學習", subTitle: "功能委員會" },
    ],
    errorMsg: {
        afterThisYear: "請輸入{{targetYear}}或之後的年份",
        beforeThisYear: "請輸入{{targetYear}}或之前的年份",
        suitableLanguage: "請以適當語言填寫{{label}}",
        subjectPanel: "科組/功能組別/其他",
        descriptionPart6: "項目/詳情",
        positionPart: "職位",
        committeePart5: "委員會/組織",
        chronological: "請輸入{{targetYear}}或之後的年份",
        subjectRequired: "請輸入對應的任教科目",
        yearBefore: "請選擇今年之前的年份",
    },

    // committeesOptions: [
    //     { key: "cle", label: "中國語文教育" },
    //     { key: "ele", label: "英國語文教育" },
    //     { key: "me", label: "數學教育" },
    //     { key: "pshe", label: "個人、社會及人文教育" },
    //     { key: "se", label: "科學教育" },
    //     { key: "te", label: "科技教育" },
    //     { key: "ae", label: "藝術教育" },
    //     { key: "pe", label: "體育" },
    //     { key: "ece", label: "幼兒教育" },
    //     { key: "sen", label: "特殊教育需要" },
    //     { key: "ge", label: "資優教育" },
    //     { key: "lrss", label: "學習資源及支援" },
    //     { key: "al", label: "應用學習" },
    // ],
};
export default Form090TC;
